import Connector, { ConnectorProps } from './connector';
import { RollingContainers as Component } from './RollingContainers';

interface RollingContainersProps extends Omit<ConnectorProps, 'component'> {}

export const RollingContainers = (props: RollingContainersProps) => {
  return <Connector {...props} component={Component} />;
};
